<!-- Notes List Container -->
<div class="w-full">
    <div class="border-b border-b-gray-300 zuper-dialog-header">
        <div class="text-xl leading-6 font-medium">{{'notes.details.title' | translate}}</div>
        <div class="flex items-center ml-auto">
            <span mat-dialog-close
                class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <div *ngIf="!note" class="filter-spinner-height flex justify-center items-center">
        <ng-container>
          <mat-progress-spinner class="self-center justify-self-center mt-8 mb-8"
          [diameter]="45"
          [mode]="'indeterminate'">
          </mat-progress-spinner>
        </ng-container>
      </div>
    <div *ngIf="note" class="note-details-body-container overflow-y-auto zuper-scrollbar p-6 pb-3">
        <div class="flex justify-between">
            <div class="flex items-center mb-4" *ngIf="note.created_by">
                <img *ngIf="hasValidProfilePicture(note.created_by.profile_picture)" loading="lazy"
                    class="w-11 h-11 rounded-lg mr-4 border" src="{{note.created_by.profile_picture}}" alt="{{note.created_by.first_name}} {{note.created_by.last_name ?? ''}}">
                <div *ngIf="!hasValidProfilePicture(note.created_by.profile_picture) && note.created_by.first_name"
                    class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 w-10 h-10 rounded-lg mr-4">
                    {{note.created_by.first_name[0]}}</div>
                <div class="flex flex-col">
                    <div class="flex">
                        <span class="font-bold text-base leading-none">{{note.created_by.first_name}}
                            {{note.created_by.last_name ?? ''}}</span>
                        <div class="flex items-center h-3 justify-center ml-2" *ngIf="isPrivateNote(note)">
                            <mat-icon class="icon-size-4 cursor-pointer" [svgIcon]="'heroicons_solid:lock-closed'"
                                matTooltip="{{'notes.panel.tooltip.only_me' | translate}}"></mat-icon>
                        </div>
                    </div>
                    <span class="text-md text-secondary leading-none mt-2">{{note.created_at | datetime}}</span>
                </div>
            </div>
            <div class="flex">
                <div class="mr-2">
                    <div class="flex items-center justify-center p-2 rounded-full hover:bg-gray-200 cursor-pointer"
                        matTooltip="{{('notes.panel.visibility_info.' + (getNoteVisibility(note) | lowercase)) | translate}}">
                        <em class="ti icon-size-5"
                            [ngClass]="{'ti-lock': getNoteVisibility(note) === 'PRIVATE','ti-world': getNoteVisibility(note) === 'PUBLIC','ti-users': getNoteVisibility(note) === 'INTERNAL' }"></em>
                    </div>
                </div>
                <div *ngIf="showEditIcon">
                    <span class="p-2 flex items-center justify-center hover:bg-gray-200 rounded-full" (click)="editNote()">
                        <em class="ti ti-pencil text-2xl"></em>
                    </span>
                </div>
            </div>
        </div>
        <div class="mt-2 break-all tinymce-text-inner-html pb-3" *ngIf="note.note || note.content"
            [innerHTML]="(note.note ?? note.content) | safeHtml">
        </div>
        <hr class="border-b mt-0 mb-3" *ngIf="note.note && note.attachments?.length">
        <div class="my-4">
            <div class="text-lg leading-6 font-medium pb-1">{{'notes.panel.sort.associated_with' | translate}}</div>
            <ng-container *ngFor="let module of allModules">
                <div *ngIf="note && checkModuleIsAssociated(module) && currentModule !== module"
                     [matTooltip]="getAssociatedModuleName(module, note[paramKey[module]])"
                     class="inline-flex items-center justify-between cursor-default mr-2 px-2.5 py-4 h-6 rounded-full text-base font-semibold mt-2 module-icon-color">
                    <em [ngClass]="getAssociatedModuleIcon(module)" class="text-2xl font-medium mr-2 module-icon-color"></em>
                    <span class="truncate max-w-50 h-5 mb-0.5">
                        <a href="/{{redirectUrl[module]}}/{{getModuleUid(module, note[paramKey[module]])}}/details">{{getAssociatedModuleName(module, note[paramKey[module]])}}</a>
                    </span>
                </div>
            </ng-container>
        </div>
        <div *ngIf="note.attachments && note.attachments.length" class="flex flex-col pb-3">
            <div>
                <span class="flex items-center">
                    <em class="ti ti-paperclip icon-size-5 mr-2 mb-1"></em>
                    <span>{{note.attachments.length}} {{'notes.panel.file.attachments' | translate}}</span>
                </span>
            </div>
            <!-- Attachments -->
            <ng-container>
                <div class="flex flex-wrap mt-3" *ngIf="getViewableAttachments(note.attachments)?.length">
                    <ng-container
                        *ngFor="let attachment of getViewableAttachments(note.attachments);let count=index">
                        <div class="flex-item-wrap p-1"
                            (click)="openGallery(note.attachments, attachment.attachment)"
                            [ngStyle]="getCursorStyle(attachment.attachment)">
                            <div class="flex items-center w-full h-52 relative">
                                <div class="z-10 text-base flex h-7 w-full absolute text-white justify-center items-center cursor-pointer font-medium text-white bg-gray-900 opacity-50"
                                    [ngClass]="{ 'bottom-0': getNoteAttachmentType(attachment.attachment) === 'IMAGE', 'top-0': getNoteAttachmentType(attachment.attachment) === 'VIDEO'}">
                                    <span class="truncate w-4/5 text-center">{{attachment.attachment_name}}</span>
                                </div>
                                <ng-container *ngIf="getNoteAttachmentType(attachment.attachment) === 'IMAGE'">
                                    <img class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 object-contain note-file-bg-default" loading="lazy"
                                         src="{{attachment.attachment}}" alt="{{attachment.attachment_name ?? ''}}" *ngIf="attachment.attachment_size < 3000">
                                    <img class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 object-contain note-file-bg-default" loading="lazy"
                                         src="assets/images/png/image_placeholder.png" alt="{{attachment.attachment_name ?? ''}}" *ngIf="attachment.attachment_size > 3000">
                                </ng-container>
                                <video controls controlsList="nodownload nofullscreen noremoteplayback"
                                    class="w-full h-52 rounded-md overflow-hidden flex-shrink-0 note-file-bg-default"
                                    *ngIf="getNoteAttachmentType(attachment.attachment) === 'VIDEO'">
                                    <source src="{{attachment.attachment}}" type="video/mp4">
                                    {{'text.video_unsupported' | translate}}
                                </video>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="flex flex-col" *ngIf="getNonViewableAttachments(note.attachments)?.length">
                    <ng-container *ngFor="let attachment of getNonViewableAttachments(note.attachments)">
                        <file-placeholder *ngIf="attachment" class="my-2 pr-4 max-w-full"
                            [options]="getPlaceholderOptions(attachment, false, true)"
                            (fileEventEmitter)="fileEventEmitHandler($event)">
                        </file-placeholder>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
    <div mat-dialog-actions class="flex justify-end border-gray-300 border-t zuper-dialog-footer">
        <div class="flex justify-around">
            <button type="button" mat-stroked-button mat-dialog-close class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none btn-small">{{'close.text' | translate}}</button>
        </div>
    </div>
</div>
<div [hidden]="true" style="width: 70%;">
    <lightgallery [settings]="settings" [onAfterAppendSubHtml]="lgAppendSubHTML" [onInit]="lightOnInit">
        <a href=""></a>
    </lightgallery>
</div>